import { ROSELoader } from './rose';
import { BinaryReader } from '../util/binaryreader';
import { BinaryWriter } from '../util/binarywriter';

export class TilemapTile {
  brush: number = 0;
  index: number = 0;
  set: number = 0;
  number: number = 0;
}

/**
 * @property {Number} width
 * @property {Number} height
 * @property {TilemapTile[]} map
 */
export class TilemapData {
  width: number = 0;
  height: number = 0;
  map: TilemapTile[] = [];

  static parse(rh: BinaryReader): TilemapData {
    const data = new TilemapData();
    data.width  = rh.readUint32();
    data.height = rh.readUint32();

    for (let i = 0; i < data.width * data.height; ++i) {
      const tile = new TilemapTile();
      tile.brush  = rh.readUint8();
      tile.index  = rh.readUint8();
      tile.set    = rh.readUint8();
      tile.number = rh.readUint32();
      data.map.push(tile);
    }
    return data;
  }

  static serialize(data: TilemapData): ArrayBuffer {
    const expected = data.width * data.height;
    if (data.width < 0 || data.height < 0 || data.map.length !== expected) {
      throw new Error(
        `Invalid TIL dimensions: ${data.width}x${data.height} requires ${expected} tiles, got ${data.map.length}`,
      );
    }

    const writer = new BinaryWriter(8 + expected * 7);
    writer.writeUint32(data.width);
    writer.writeUint32(data.height);
    for (let index = 0; index < data.map.length; index++) {
      const tile = data.map[index];
      for (const [name, value, maximum] of [
        ['brush', tile.brush, 0xff],
        ['index', tile.index, 0xff],
        ['set', tile.set, 0xff],
        ['number', tile.number, 0xffffffff],
      ] as const) {
        if (!Number.isInteger(value) || value < 0 || value > maximum) {
          throw new Error(`Invalid TIL tile ${index} ${name}: ${value}`);
        }
      }
      writer.writeUint8(tile.brush);
      writer.writeUint8(tile.index);
      writer.writeUint8(tile.set);
      writer.writeUint32(tile.number);
    }
    return writer.toArrayBuffer();
  }

  static load(path: any, callback: any) {
    ROSELoader.load(path, function(rh: any) {
      callback(TilemapData.parse(rh));
    });
  }
}
